import { ActivityProgressApplyScoreFilter, RaasQuizMetricType } from './remediation-student-activity.models';
import { RemediationAssignmentSourceTypeDto } from '../../apis/nhe-remediation-service/nhe-remediation-service.dtos';

export const ActivityProgressApplyScoreFilterDisplayName: Record<ActivityProgressApplyScoreFilter, string> = {
  [ActivityProgressApplyScoreFilter.BEST_ATTEMPT]: 'Best Attempt',
  [ActivityProgressApplyScoreFilter.FIRST_ATTEMPT]: 'First Attempt',
  [ActivityProgressApplyScoreFilter.AVG_ALL_ATTEMPTS]: 'Average of All Attempts',
  [ActivityProgressApplyScoreFilter.AVG_FIRST_TWO_ATTEMPTS]: 'Average of First Two Attempts',
};

export const ActivityNameFilterDefaultTitle = 'Select activity';
// Use - to indicate empty value that will be populated later
export const EmptyValueDisplay = '--';
// Use N/A to indicate that the value isn't relevant (i.e. score for non-scored content types, quiz session status in Activity Log)
export const NotApplicableDisplay = 'N/A';

export const RaasQuizMetricTypeDisplayName: Record<RaasQuizMetricType, string> = {
  [RaasQuizMetricType.QUESTIONS_ATTEMPTED]: 'Questions Attempted',
  [RaasQuizMetricType.QUESTIONS_CORRECT]: 'Questions Correct',
  [RaasQuizMetricType.FIRST_ATTEMPT_SCORE]: 'First Attempt Score',
  [RaasQuizMetricType.CURRENT_SCORE]: 'Current Score',
  [RaasQuizMetricType.TOTAL_TIME_SPENT]: 'Total Time Spent',
};

export const RemediationAssignmentSourceTypeDisplayName: Record<RemediationAssignmentSourceTypeDto, string> = {
  [RemediationAssignmentSourceTypeDto.HESI_EXAM_EDITION__EDITION_ID]: 'Exam'
};
